import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle2 } from '@src/elements/typography/typography'

const preventDefault = (handler) => (event) => {
  event.preventDefault()
  return handler()
}

export type ListColumnValueType = 'string' | 'float' | 'date' | 'html' | 'object'

export type ListColumnHeaders = { [key: string]: { headerLabel: string | HTMLElement | ListColumnHeaders, type: ListColumnValueType, disableSorting?: boolean } }

@Component
export class ListHeader extends Vue {

  @Prop({ required: false })
  columns: ListColumnHeaders
  private sortKey: string | null = null
  private sortDir: 'desc' | 'asc' = 'asc'

  sortBy (key: string, type: ListColumnValueType) {
    if (key === this.sortKey) {
      if (this.sortDir === 'desc') {
        this.sortKey = null
      } else {
        this.sortDir = 'desc'
      }
    } else {
      this.sortKey = key
      this.sortDir = 'asc'
    }
    this.$parent!.$emit('sortBy', this.sortKey, this.sortDir, type)
  }

  render (h: CreateElement) {
    let headerLabel: any = null

    let caption = (key, label) => {
      if (label.type === 'object') {
        return Object.entries(label.headerLabel).map(([nestedKey, nestedLabel]) => {
          return caption(nestedKey, nestedLabel)
        })
      } else if (label.type === 'html') {
        return label.headerLabel
      } else {
        if (label.disableSorting) {
          return <Subtitle2 class={`${this.sortDir} ${this.sortKey === key ? 'active' : ''}`}>{label.headerLabel}</Subtitle2>
        } else {
          return <Subtitle2 class={`${this.sortDir} ${this.sortKey === key ? 'active' : ''}`}><span
            onClick={preventDefault(() => this.sortBy(key, label.type))}>{label.headerLabel}</span></Subtitle2>
        }
      }
    }

    return <div class='header'>

      {Object.entries(this.columns).map(([key, label]) => {
        headerLabel = caption(key, label)

        return <div class='header-cell'>
          {headerLabel}
        </div>
      })}
    </div>
  }

}
